import React from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Check from 'images/check.svg'

const SuccessModal = ({ closeModal, msg, translate }) => (
  <section className='tracking-monitor-errorSuccess'>
    <p>
      <img src={Check} />
    </p>
    <h3>
      <strong>{translate('option.success')}</strong>
    </h3>
    <p>{translate(`label.help.config.success.${msg}`)}</p>

    <Row className='margin-top-quadruple'>
      <Col xs={4} xsOffset={4}>
        <button
          className='button button-primary button-full'
          onClick={closeModal}
        >
          {translate('ok_button')}
        </button>
      </Col>
    </Row>
  </section>
)

SuccessModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  msg: PropTypes.any.isRequired,
  translate: PropTypes.func.isRequired,
}

export default SuccessModal
